import { safeExecuteMobileVerification } from "./common/verificationFlow";
import Mdn from "./shared/mdn";
import { VerificationFlowStatus } from "./common/verificationFlow";

function updateStatusLabel(status: string) {
    let statusLabel = document.getElementById('statusLabel');
    if (statusLabel) {
        statusLabel.innerText = status;
    }
}

export async function pocSiteDoMobileVerify() {

    let mdnInput = document?.getElementById('mdn') as HTMLInputElement;
    let mdn = mdnInput?.value || '';
    const mdnObj = Mdn.parseMdn(mdn);
    if (!mdnObj) {
        console.log('Invalid MDN');
        return;
    }
    
    const verificationFlowResult = await safeExecuteMobileVerification('MOCK_USER_ID', 'MOCK_SITE_ID', '1', mdnObj, '10000');
    let statusMessage;
    let errorData: string = '';
    switch (verificationFlowResult.status) {
        case VerificationFlowStatus.CHOSE_NOT_TO_VERIFY:
            statusMessage = `CHOSE_NOT_TO_VERIFY`;
            break;
        case VerificationFlowStatus.VERIFICATION_PROCEDURE_ERROR:
            statusMessage = `VERIFICATION_PROCEDURE_ERROR`;
            errorData = verificationFlowResult.errorString || '';
            break;
        case VerificationFlowStatus.VERIFICATION_PROCEDURE_COMPLETED_SUCCESSFULLY:
            statusMessage = `VERIFICATION_PROCEDURE_COMPLETED_SUCCESSFULLY`;
            break;
        default:
            statusMessage = `UNEXPECTED_STATUS`;
            break;
    }
    updateStatusLabel(statusMessage + '\n' + errorData);
}